import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getProspectusExposureTypes, saveBatchProspectusExposureTypes } from '../../api/prospectusExposureTypes';
import type { ProspectusExposureType } from '../../types/ProspectusExposureType';
import { t } from '../../i18n/t';

const columnDefs: ColDef<ProspectusExposureType>[] = [
  {
    field: 'prospectusExposureTypeId',
    headerName: t('prospectusExposureTypes.columns.prospectusExposureTypeId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<ProspectusExposureType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'prospectusExposureTypeName', headerName: t('prospectusExposureTypes.columns.prospectusExposureTypeName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<ProspectusExposureType> => ({ prospectusExposureTypeId: 0, prospectusExposureTypeName: '' });

export function ProspectusExposureTypesPage() {
  return (
    <LopCrudPage<ProspectusExposureType>
      resourceCode="prospectusExposureTypes"
      titleKey="prospectusExposureTypes.pageTitle"
      idField="prospectusExposureTypeId"
      getRows={getProspectusExposureTypes}
      saveBatch={(added, modified, deletedIds) => saveBatchProspectusExposureTypes(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
